import { render, staticRenderFns } from "./TopCities.vue?vue&type=template&id=8985de7c&"
import script from "./TopCities.vue?vue&type=script&lang=js&"
export * from "./TopCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports